import {Component} from '@angular/core';
import {MessageService} from 'primeng/api';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {catchError, finalize, throwError} from 'rxjs';
import {AuthService} from "../../service/auth.service";
import {FormsModule} from "@angular/forms";
import {Button} from "primeng/button";
import {InputTextModule} from "primeng/inputtext";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    Button,
    InputTextModule,
    NgIf
  ]
})
export class ForgotPasswordComponent {
  email!: string;
  emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  showResendEmail: boolean = false;
  resendEmailDisable: boolean = false;
  timerResend: number = 0;
  loading: boolean = false;

  constructor(
    private ref: DynamicDialogRef,
    private messageService: MessageService,
    private userService: AuthService
  ) {
  }

  sendEmail(): void {
    if (this.email == undefined || !this.emailRegex.test(this.email))
      return;

    this.loading = true;
    this.userService.forgotPassword(this.email)
      .pipe(
        finalize(() => this.loading = false),
        catchError((err) => {
          this.messageService.add({
            key: 'toastError',
            severity: 'error',
            summary: 'Erro',
            detail: 'E-mail informado incorreto!',
          });
          return throwError(err);
        }),
      )
      .subscribe({
        next: (_) => {
          this.messageService.add({
            key: 'toastError',
            severity: 'Success',
            summary: 'Esqueci a senha',
            detail: 'E-mail enviado com sucesso!',
          });
          this.showResendEmail = true;
          this.initTimer();
          this.close();
        }
      })
  }

  initTimer(): void {
    this.resendEmailDisable = true;
    this.timerResend = 5;
    let timerCounter = setInterval(() => {
      if (this.timerResend != 0) {
        this.timerResend--;
      } else {
        this.resendEmailDisable = false;
        clearInterval(timerCounter);
      }
    }, 1000);
  }

  resendEmail(): void {
    if (this.timerResend != 0) {
      this.messageService.add({
        key: 'toastError',
        severity: 'error',
        summary: 'Erro',
        detail: 'Aguarde um momento!',
      });
      return;
    }

    this.messageService.add({
      key: 'toastError',
      severity: 'Success',
      summary: 'Esqueci a senha',
      detail: 'E-mail enviado com sucesso!',
    });
    this.initTimer();
  }


  close(): void {
    this.ref.close();
  }

}
